import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { ScopingHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { AssociatedProjects } from '@shared/components';
import { ScopingActions } from '@store/actions';
import { ScopingSelectors } from '@store/selectors';

type ScopingAssociatedProjectsProps = RouteComponentProps & {
  isActive?: boolean;
};

export const ScopingAssociatedProjects: FC<ScopingAssociatedProjectsProps> = ({
  isActive,
  ...props
}: ScopingAssociatedProjectsProps) => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();
  const isLoading = useSelector(
    ScopingSelectors.getTabLoadingState('associatedProjects'),
  );
  const isDataLoaded = useSelector(
    ScopingSelectors.getTabLoadedState('associatedProjects'),
  );
  const { PSLocationCode, projects, isSiteOn } = useSelector(
    ScopingSelectors.getScopingAssociatedProjectsData,
  );

  useEffect(() => {
    if (isActive && !isDataLoaded && !isLoading) {
      dispatch(
        ScopingActions.setTabLoading.done({
          tabName: 'associatedProjects',
          isLoading: true,
        }),
      );
      HttpService.getHttpRequests(ScopingHttpService)
        .getScopingAssociatedProjects(projectBundleID)
        .catch(() =>
          dispatch(
            ScopingActions.setTabError.done({
              tabName: 'associatedProjects',
              hasError: true,
            }),
          ),
        );
    }
  }, [dispatch, isActive, isDataLoaded, isLoading, projectBundleID]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-scoping-associated-projects loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <AssociatedProjects
      {...props}
      linkId={PSLocationCode?.toString()}
      data={projects ?? []}
      isSiteOn={isSiteOn || false}
    />
  );
};
